import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

// make Masonry a jQuery plugin
//jQueryBridget('masonry', Masonry, $);

//// now you can use $().masonry()
//$('.grid').masonry({
//    columnWidth: 200,
//});

export function initMasonry() {
    if (!$('#grid').length) return;

    

    var imgLoad = imagesLoaded('#grid');
    imgLoad.on('progress', function (image, elem, message) {
        //$grid.reloadItems();
        //console.log("Progress: " + message);

        
    })
    imgLoad.on('fail', function () {
        console.log('all images loaded, at least one is broken');
    })
    imgLoad.on('always', function (instance) {
        console.log("Always: " + instance);
        var $grid = new Masonry('#grid', {
            itemSelector: '.grid-item', 
            percentPosition: true,
            columnWidth: '.grid-sizer',
            gutter: 32,
            transitionDuration: 0
        });
        //$('#grid').animate({ opacity: 1 })
    });
}


